import styled from "styled-components";

export const Logo = styled.h1`
  color: var(--color-grey600);
  font-weight: 600;
  font-size: var(--font-title3);
  & > span {
    color: var(--color-secondary);
    font-size: var(--font-headline);
 }
`;
